import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from '../../../../../components/formatted-currency';
import style from './style.module.less';
import { messages } from './messages';

export const TotalLabelHistoryCost = ({ shippingCostCurrencyCode = '', shippingCostTotal = 0 }) => {
  return (
    <div className={style['label-history-cost']}>
      <FormattedMessage
        {...messages.shippingCostLabel}
        values={{
          cost: () => <FormattedCurrency currencyCode={shippingCostCurrencyCode} value={shippingCostTotal} />,
        }}
      />
    </div>
  );
};

TotalLabelHistoryCost.propTypes = {
  shippingCostCurrencyCode: PropTypes.string,
  shippingCostTotal: PropTypes.number,
};
